import React, { useEffect } from 'react';
import { Platform, View, ViewStyle } from 'react-native';

import styles from './keyboard-key-indicator.style';
import { useColors } from '../../hooks';
import { useKeyPress } from '../../hooks/use-key-press';
import ThemedText2 from '../themed-text-2';

interface KeyboardKeyIndicatorProps {
  keyCode: string;
  onKeyPress: () => void;
  style?: ViewStyle;
  disabled?: boolean;
}

const isWeb = Platform.OS === 'web';

export default function KeyboardKeyIndicator({
  keyCode,
  onKeyPress,
  style,
  disabled = false,
}: KeyboardKeyIndicatorProps) {
  const isKeyPressed = useKeyPress(keyCode);
  const colors = useColors();

  useEffect(() => {
    if (!isKeyPressed || !onKeyPress || !isWeb || !!disabled) {
      return;
    }

    onKeyPress();
  }, [isKeyPressed, onKeyPress, disabled]);

  if (!isWeb || !keyCode || !onKeyPress || !!disabled) {
    return null;
  }

  return (
    <View
      style={[
        styles.container,
        { backgroundColor: colors.background, borderColor: colors.borderColor },
        style,
      ]}
    >
      <ThemedText2>{keyCode}</ThemedText2>
    </View>
  );
}
